import { render, staticRenderFns } from "./InvoicePanel.vue?vue&type=template&id=2f8b5239&scoped=true&"
import script from "./InvoicePanel.vue?vue&type=script&lang=ts&"
export * from "./InvoicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvoicePanel.vue?vue&type=style&index=1&id=2f8b5239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b5239",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
